export enum EPermissionActions {

  ACTION_MODULO = 'modulo',

  ACTION_API_G1 = 'api/g1',

  ACTION_API_KEYS_AUTH_MANAGEMENT = 'api/apiKeysAuthManagement',

  ACTION_CHANNELS = 'channels',

  ACTION_BUSINESS_CLIENTS = 'businessClients',
  ACTION_BUSINESS_CLIENTS_CREATE = 'businessClients/create',
  ACTION_BUSINESS_CLIENTS_UPDATE = 'businessClients/update',

  ACTION_COMMUNITIES = 'communities',
  ACTION_COMMUNITIES_CREATE = 'communities/create',
  ACTION_COMMUNITIES_UPDATE = 'communities/update',
  ACTION_COMMUNITIES_ADMIN = 'communities/admin',
  ACTION_SECURITY_CODES_GENERATE = 'securityCodes/generate',

  ACTION_INVOICES = 'invoices',

  ACTION_LANDINGPAGES = 'langingpages',
  ACTION_LANDINGPAGES_CREATE = 'landingpages/create',
  ACTION_LANDINGPAGES_DELETE = 'landingpages/delete',

  ACTION_LOCKERS = 'lockers',
  ACTION_LOCKERS_CREATE = 'lockers/create',
  ACTION_LOCKERS_UPDATE = 'lockers/update',
  ACTION_LOCKERS_MODULES = 'lockers/modules',

  ACTION_LOCKERS_INSTALL = 'lockers/install',
  ACTION_LOCKERS_OPENCELL = 'lockers/openCell',
  ACTION_LOCKERS_AVAILABLECELLS = 'lockers/availableCells',
  ACTION_LOCKERS_FINANCES_VIEW = 'lockers/finances/view',
  ACTION_FINANCES_UPDATE = 'lockers/finances/update',

  ACTION_LOCKER_COMPANIES = 'lockerCompanies',

  ACTION_ORDERS = 'orders',
  ACTION_ORDERS_CREATE = 'orders/create',
  ACTION_ORDERS_UPDATE = 'orders/update',
  ACTION_ORDERS_USER = 'orders/user',
  ACTION_ORDERS_PROCESS = 'orders/process',
  ACTION_ORDERS_WEBHOOK = 'orders/webhook',
  ACTION_ORDERS_DEV_EVENT = 'orders/devEvent',
  ACTION_ORDERS_LIMITED_FILTERS_ACCESS = 'orders/limitedFiltersAccess',
  ACTION_ORDERS_ALL_FILTERS_ACCESS = 'orders/allFiltersAccess',
  ACTION_WEBHOOK_ADMIN = 'webhook/admin',

  ACTION_REPORTS = 'reports',

  ACTION_ROUTES = 'routes',
  ACTION_ROUTES_VIEW          = 'routes/view',
  ACTION_ROUTES_CREATE        = 'routes/create',
  ACTION_ROUTES_EDIT          = 'routes/edit',
  ACTION_ROUTES_DELETE        = 'routes/delete',
  ACTION_ROUTES_ADMIN         = 'routes/admin',
  ACTION_ROUTES_SEE_MY_ROUTES = 'routes/seeMyRoutes',

  ACTION_SCREENSAVERS = 'screensavers',
  ACTION_SCREENSAVERS_UPDATE = 'screensavers/update',

  ACTION_SERVICE_PROVIDERS = 'serviceProviders',
  ACTION_SERVICE_PROVIDERS_UPDATE = 'serviceProviders/update',
  ACTION_SERVICE_PROVIDERS_DELETE = 'serviceProviders/delete',
  ACTION_SERVICE_PROVIDERS_METRICS = 'metrics/access',
  ACTION_SERVICE_PROVIDERS_METRICS_READ = 'metrics/read',

  // Helpdesk: access = everything but Gmail accounts; admin = also Gmail accounts.
  ACTION_HELPDESK_ACCESS = 'helpdesk/access',
  ACTION_HELPDESK_ADMIN = 'helpdesk/admin',
  // WhatsApp chats inside the helpdesk (admin also opens them).
  ACTION_HELPDESK_WHATSAPP = 'helpdesk/whatsapp',

  ACTION_IDENTITY_INTEGRATIONS = 'identityIntegrations',
  ACTION_IDENTITY_INTEGRATIONS_MANAGE = 'identityIntegrations/manage',
  ACTION_IDENTITY_INTEGRATIONS_AUDIT = 'identityIntegrations/audit',

  ACTION_SETTINGS = 'settings',
  ACTION_SETTINGS_AUDIT_LOGS = 'settings/auditLogs',
  ACTION_SETTINGS_COURIERS = 'settings/couriers',
  ACTION_SETTINGS_HOLIDAYS  = 'settings/holidays',
  ACTION_SETTINGS_PERMISSIONS = 'settings/permissions',
  ACTION_SETTINGS_ZONES  = 'settings/zones',

  ACTION_SWAGGER = 'swagger',
  ACTION_SWAGGER_G1 = 'swagger/g1',

  ACTION_PROMOTIONS = 'promotions',
  ACTION_PROMOTIONS_CREATE = 'promotions/create',
  ACTION_PROMOTIONS_UPDATE = 'promotions/update',
  ACTION_PROMOTIONS_DELETE = 'promotions/delete',

  ACTION_PROVIDERS = 'providers',
  ACTION_PROVIDERS_CREATE = 'providers/create',
  ACTION_PROVIDERS_ASSIGN = 'providers/assign',
  ACTION_PROVIDERS_EDIT = 'providers/edit',
  ACTION_PROVIDERS_DELETE = 'providers/delete',

  ACTION_B2B_INVITES_CREATE = 'b2bInvites/create',
  ACTION_B2B_INVITES_DELETE = 'b2bInvites/delete',

  ACTION_USERS = 'users',
  ACTION_USERS_PERMISSIONS = 'users/permissions',
  ACTION_USERS_UPDATE = 'users/update',
  ACTION_USERS_ALLOW_EDIT_HIMSELF = 'users/allowEditHimself',
  ACTION_USERS_IMPORT = 'users/import',
  ACTION_USERS_DIFFUSION_EXPRESS = 'users/diffusionExpress',
  ACTION_USERS_DIFFUSION_EXPRESS_OVERRIDE = 'users/diffusionExpressOverride',
  ACTION_USERS_WEBHOOK = 'users/webhook',
  ACTION_USERS_LOGS = 'users/logs',

}
